import { push } from "connected-react-router";

import axios from "axios";
import constants from "../constants";
import { setUserDetails, setUserLogin } from "../User/reducer";

const setRegisterConfirm = (isRegistered, token) => {
  return {
    type: constants.reducerActions.registered,
    isRegistered,
    token,
  };
};

export const signUpClient = (clientDetails) => async (dispatch) => {
  try {
    const url = `/client/register`;
    const { responseStatus, responseBody } = await axios.post(
      url,
      clientDetails
    );
    console.log(responseBody, responseStatus);
    if (responseStatus === constants.status.created) {
      const { data } = responseBody;
      dispatch(setRegisterConfirm(true, data.access_token));
      dispatch(setUserLogin(data.access_token, constants.roles.client));
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("role", constants.roles.client);
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

export const createT24Profile = (profileDetails) => async (dispatch) => {
  try {
    const url = "/client/T24Profile";
    const { responseStatus } = await axios.post(url, profileDetails);
    if (responseStatus === constants.status.created) {
      dispatch(getAllProfiles());
    }
  } catch (error) {
    console.log(error);
  }
};

const setAllJobs = (jobs, totalJobsCount, fetchingJobs) => {
  return {
    type: constants.reducerActions.allJobs,
    jobs,
    totalJobsCount,
    fetchingJobs,
  };
};

const setFetching = (isFetching) => {
  return {
    type: constants.reducerActions.fetchingJobs,
    isFetching,
  };
};

export const getAllJobs = (page) => async (dispatch) => {
  try {
    const url = `/client/jobs?page=${page}&size=5`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllJobs(data.items, data.total, false));
    }
    return { responseStatus };
  } catch (error) {
    console.log(error);
  }
};

const jobCreated = (isCreated) => {
  return {
    type: constants.clientActions.jobCreated,
    isCreated,
  };
};

export const createJob = (jobDetails) => async (dispatch) => {
  try {
    const url = "/client/job";
    const { responseStatus, responseBody } = await axios.post(url, jobDetails);
    console.log(responseStatus, responseBody);
    if (responseStatus === constants.status.created) {
      dispatch(jobCreated(true));
      dispatch(push("/client/home"));
    }
  } catch (error) {
    console.log(error);
  }
};

const setJobDetail = (jobDetail, isFetching) => {
  return {
    type: constants.reducerActions.jobDetail,
    jobDetail,
    isFetching,
  };
};

export const getJobDetail = (jobId) => async (dispatch) => {
  try {
    dispatch(setFetching(true));
    const url = `/client/jobs/${jobId}`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setJobDetail(data, false));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateJobDetail = (jobId, jobDetails) => async (dispatch) => {
  try {
    const url = `/client/jobs/${jobId}`;
    const { responseStatus } = await axios.put(url, jobDetails);
    if (responseStatus === constants.status.success) {
      dispatch(push("/client/home"));
    }
  } catch (error) {
    console.log(error);
  }
};

export const setAllApplications = (applications) => {
  return {
    type: constants.clientActions.applications,
    applications,
  };
};

export const getApplications = (jobId) => async (dispatch) => {
  try {
    const url = `/client/jobs/${jobId}/applications`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setAllApplications(data.items));
    }
    return responseStatus;
  } catch (error) {
    console.log(error);
  }
};

export const giveOffer = (applicationId) => async (dispatch) => {
  try {
    const url = `/client/job/applications/${applicationId}/offer`;
    const { responseStatus } = await axios.post(url);
    return { responseStatus };
  } catch (error) {
    console.log(error);
  }
};

const searchJobsCount = (jobCount) => {
  return {
    type: constants.consultantActions.searchJobs,
    jobCount,
  };
};

export const searchJobs = (searchText, page) => async (dispatch) => {
  try {
    const url = `/client/job/search?Search=${searchText}&page=${page}&size=10`;
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(searchJobsCount(data.total));
      const searchedJobs = data.items;
      return { searchedJobs, responseStatus };
    }
  } catch (error) {
    console.log(error);
    return { responseStatus: error.response.status };
  }
};

const dashboardDetails = (details) => {
  return {
    type: constants.clientActions.dashboard,
    details,
  };
};

export const getDashboardDetails = () => async (dispatch) => {
  try {
    const url = "/client/dashboard";
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseStatus, responseBody);
    if (responseStatus === constants.status.success) {
      dispatch(dashboardDetails(responseBody));
    }
  } catch (error) {
    console.log(error);
  }
};

export const getClientPersonalDetails = () => async (dispatch) => {
  try {
    const url = "/client/personal-info";
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseBody, responseStatus);
    if (responseStatus === constants.status.success) {
      dispatch(setUserDetails(responseBody.data));
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateClientDetails =
  (
    firstName,
    lastName,
    mobileNumber,
    country,
    jobTitle,
    bankName,
    address,
    profileImageId
  ) =>
  async (dispatch) => {
    try {
      const url = "/client/personal-info";
      const data = {
        firstName,
        lastName,
        mobileNumber,
        country,
        jobTitle,
        bankName,
        address,
        profileImageId,
      };
      const { responseStatus } = await axios.put(url, data);
      if (responseStatus === constants.status.success) {
        await dispatch(getClientPersonalDetails());
      }
    } catch (error) {
      console.log(error);
    }
  };

const updateAllProfiles = (profiles) => {
  return {
    type: constants.clientActions.updateT24,
    profiles,
  };
};

export const getAllProfiles = () => async (dispatch) => {
  try {
    const url = "/client/T24Profile";
    const { responseStatus, responseBody } = await axios.get(url);
    console.log(responseStatus, responseBody);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(updateAllProfiles(data));
    }
  } catch (error) {
    console.log(error);
  }
};

const setProfileCompletion = (profileCompletion) => {
  return {
    type: constants.clientActions.profileCompletion,
    profileCompletion,
  };
};

export const getProfileCompletion = () => async (dispatch) => {
  try {
    const url = "/client/profileCompletion";
    const { responseStatus, responseBody } = await axios.get(url);
    if (responseStatus === constants.status.success) {
      const { data } = responseBody;
      dispatch(setProfileCompletion(data.profileCompletion));
    }
  } catch (error) {
    console.log(error);
  }
};
